import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';

const user = getLoggedUser();
const endpoint = apiUrl + 'v2';

export const getSiteVisitRegistrationById = async (registrationId) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + user.token,
        },
    };
    try {
        const response = await axios.get(`${endpoint}/site-visit-form/${registrationId}`, config);
        return response.data;
    } catch (error) {
        console.error('Error fetching registration:', error);
        throw error;
    }
};

export const updateSiteVisitRegistration = async (registrationId, formData) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + user.token,
        },
    };
    try {
        const response = await axios.put(`${endpoint}/site-visit-form/${registrationId}`, formData , config);
        return response.data;
    } catch (error) {
        console.error('Error updating registration:', error);
        throw error;
    }
};

export const verifySiteVisitReg = async (registrationId, formData) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + user.token,
        },
    };
    try {
        const response = await axios.put(`${endpoint}/site-visit-form-verify/${registrationId}`, formData , config);
        return response.data;
    } catch (error) {
        console.error('Error updating registration:', error);
        throw error;
    }
};